export const LIST_HEIGHT = 428;
export const READ_ONLY_LIST_HEIGHT = 300;
export const LIST_HEADER = 72;
export const ITEM_SIZE = 28;
export const PADDING_SIZE = 8;
export const HEADER_GUTTER_SIZE = 16;
export const OVERSCAN_EXTRA_ITEMS = 8;
export const BULK_BTN_SIZE = 40;
export const ITEM_INDENTATION = 1.5;
export const SUB_ITEM_INDENTATION = 1;
export const FOOTER_HEIGHT = 47;
